import type { IconData } from '@stacksjs/iconify-core'

export const notificationAlarmSnooze: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-width=\"3\"><path stroke-linecap=\"round\" d=\"M40.08 25A16 16 0 0 0 42 29.575l1.471 2.384c1.478 2.393.672 4.866-2.116 5.237C38.166 37.62 32.842 38 24 38s-14.167-.38-17.355-.804c-2.788-.371-3.594-2.844-2.117-5.237L6 29.575a16 16 0 0 0 2.326-7.037l.48-5.59C9.48 9.06 16.08 3 24 3c1.934 0 3.79.362 5.5 1.023\"/><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M33 8h11L34 20h11m-22-4h7.333l-6.666 8H31\"/><path d=\"M16.047 37.878a8.001 8.001 0 0 0 15.905 0\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default notificationAlarmSnooze
